import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import DropdownSelect, { SelectType } from '../../../components/DropdownSelect';
import InventoryModal from '../../../components/modal/InventoryModal';
import ProductController, {
  CategoryType,
  InventoryType,
} from '../../../controller/ProductController';
import { useToast } from '../../../controller/ToastController';
import { AuthContext } from '../../../navigation/AuthProvider';
import { useOutletContext } from 'react-router-dom';
import { CurrentStoreContext } from '../../../controller/StoreController';

const stockTimeList: SelectType[] = [
  { key: 1, value: '01:00:00', name: '01시', label: '01시' },
  { key: 2, value: '02:00:00', name: '02시', label: '02시' },
  { key: 3, value: '03:00:00', name: '03시', label: '03시' },
  { key: 4, value: '04:00:00', name: '04시', label: '04시' },
  { key: 5, value: '05:00:00', name: '05시', label: '05시' },
  { key: 6, value: '06:00:00', name: '06시', label: '06시' },
  { key: 7, value: '07:00:00', name: '07시', label: '07시' },
  { key: 8, value: '08:00:00', name: '08시', label: '08시' },
  { key: 9, value: '09:00:00', name: '09시', label: '09시' },
  { key: 10, value: '10:00:00', name: '10시', label: '10시' },
  { key: 11, value: '11:00:00', name: '11시', label: '11시' },
  { key: 12, value: '12:00:00', name: '12시', label: '12시' },
  { key: 13, value: '13:00:00', name: '13시', label: '13시' },
  { key: 14, value: '14:00:00', name: '14시', label: '14시' },
  { key: 15, value: '15:00:00', name: '15시', label: '15시' },
  { key: 16, value: '16:00:00', name: '16시', label: '16시' },
  { key: 17, value: '17:00:00', name: '17시', label: '17시' },
  { key: 18, value: '18:00:00', name: '18시', label: '18시' },
  { key: 19, value: '19:00:00', name: '19시', label: '19시' },
  { key: 20, value: '20:00:00', name: '20시', label: '20시' },
  { key: 21, value: '21:00:00', name: '21시', label: '21시' },
  { key: 22, value: '22:00:00', name: '22시', label: '22시' },
  { key: 23, value: '23:00:00', name: '23시', label: '23시' },
  { key: 24, value: '00:00:00', name: '24시', label: '24시' },
];

const Inventory = () => {
  const showToast = useToast();
  const [visibleModal, setVisibleModal] = useState<boolean>(false);
  const [inventory, setInventory] = useState<InventoryType[]>([]);
  const [categoryList, setCategoryList] = useState<SelectType[]>([
    { key: -1, value: { id: -1, is_for_adult: 0 }, name: '', label: '' },
  ]);

  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [selectAll, setSelectAll] = useState<boolean>(false);

  // 카테고리 선택
  const onChangeCategory = (e: any) => {
    getInventory(e.value.id);
  };

  const onChangeStockUpdateType = (e: any, index: number) => {
    inventory[index].stock_update_type = inventory[index].stock_update_type === 1 ? 0 : 1;
    setInventory([...inventory]);
  };
  const onChangeDefaultValue = (defaultStock: number, setDefaultStock: any, index: number) => {
    if (isNaN(defaultStock)) {
      inventory[index].default_stock = 0;
      setDefaultStock(0);
    } else inventory[index].default_stock = defaultStock;
    setInventory([...inventory]);
  };
  const onChangeInStock = (inStock: number, setInStock: any, index: number) => {
    if (isNaN(inStock)) {
      inventory[index].in_stock = 0;
      setInStock(0);
    } else inventory[index].in_stock = inStock;
    setInventory([...inventory]);
  };

  //체크박스 모두 선택
  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setInventory(
      inventory.map((item) => ({
        ...item,
        stock_update_type: newSelectAll ? 1 : 0,
      })),
    );
  };

  // API 호출
  const getCategoryData = async () => {
    try {
      const oRes = await ProductController.getAllCateProduct(currentStore.value);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getCategoryData', oResponse);
        if (oResponse.data) {
          let updatedList: any = [];
          oResponse.data.map((item: CategoryType, index: number) => {
            updatedList.push({
              key: index,
              value: { id: item.category_id, is_for_adult: item.is_for_adult },
              name: item.category_name,
              label: item.category_name,
            });
          });
          if (updatedList.length > 0) {
            setCategoryList([...updatedList]);
            getInventory(updatedList[0].value.id);
          }
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const getInventory = async (categoryId: number) => {
    try {
      const oRes = await ProductController.getSupplyProduct(currentStore.value, categoryId);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('getSupplyProduct', oResponse);
        if (oResponse.data) {
          setInventory([...oResponse.data]);
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };
  const editInventory = async () => {
    try {
      const inventoryTemp: any = [];
      inventory.map((item: InventoryType) => {
        inventoryTemp.push({
          store_id: currentStore.value,
          product_id: item.prd_id,
          stock_update_type: item.stock_update_type,
          in_stock: item.in_stock,
          default_stock: item.default_stock,
          stock_update_time: item.stock_update_time,
        });
      });

      const oRes = await ProductController.setSupplyProduct(inventoryTemp);

      if (oRes && oRes.data) {
        const oResponse = oRes.data;
        console.log('setSupplyProduct', oResponse);
        if (oResponse.data && oResponse.ok) {
          showToast('재고 정보를 수정했어요');
        }
      }
    } catch (err) {
      console.log('err---->', err);
    }
  };

  useEffect(() => {
    getCategoryData();
  }, [currentStore]);

  type InventoryItemProps = {
    item: InventoryType;
    index: number;
  };

  const RenderInventoryItem = ({ item, index }: InventoryItemProps) => {
    const [defaultStock, setDefaultStock] = useState<number>(item.default_stock);
    const [inStock, setInStock] = useState<number>(item.in_stock);

    const onChangeStockTime = (e: any) => {
      inventory[index].stock_update_time = e.value;
      console.log(inventory[index]);
      setInventory([...inventory]);
    };

    return (
      <div className="tableContent">
        <div className="productCheck">
          <input
            className="checkbox_cus"
            type="checkbox"
            style={{ width: '18px', height: '18px' }}
            checked={item.stock_update_type === 1}
            onChange={(e) => onChangeStockUpdateType(e, index)}
          />
        </div>
        <div className="productName">
          <h3>{item.prd_name}</h3>
        </div>
        <div className="productCount">
          <h3>{item.in_stock.toLocaleString()}개</h3>
        </div>
        <div className="todayStock">
          <input
            type="number"
            placeholder="수량입력"
            value={defaultStock}
            min="0"
            onChange={(e) => setDefaultStock(parseInt(e.target.value))}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onChangeDefaultValue(defaultStock, setDefaultStock, index);
              }
            }}
            onBlur={(e) => onChangeDefaultValue(defaultStock, setDefaultStock, index)}
          />
        </div>
        <div className="todayStockTime">
          <DropdownSelect
            options={stockTimeList}
            defaultValue={{
              key: 0,
              value: item.stock_update_time,
              name:
                stockTimeList.find(
                  (listItem: SelectType) => listItem.value === item.stock_update_time,
                ) === undefined
                  ? '시간 선택 안함'
                  : stockTimeList.find(
                      (listItem: SelectType) => listItem.value === item.stock_update_time,
                    )!.name,
            }}
            onChangeValue={onChangeStockTime}
          />
        </div>
        <div className="nowStock">
          <input
            type="number"
            placeholder="수량입력"
            value={inStock}
            onChange={(e) => setInStock(parseInt(e.target.value))}
            min="0"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onChangeInStock(inStock, setInStock, index);
              }
            }}
            onBlur={(e) => onChangeInStock(inStock, setInStock, index)}
          />
        </div>
      </div>
    );
  };

  return (
    <Style>
      <div className="contentContainer">
        <div className="infoWrap">
          <button onClick={() => setVisibleModal(true)} className="guideWrap">
            <img src={`${process.env.PUBLIC_URL}/svg/ic_guide.svg`} alt="가이드 아이콘" />
          </button>
          <div className="category">
            <DropdownSelect
              options={categoryList}
              defaultValue={categoryList[0]}
              onChangeValue={onChangeCategory}
            />
          </div>
          <div className="allCheck">
            <label htmlFor="allCheckbox">
              <input
                className="check"
                id="allCheckbox"
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
              />
              <p>전체선택</p>
            </label>
          </div>
          <div className="inventoryTable">
            <div className="tabletitle">
              <h2 className="productCheck">사용 여부</h2>
              <h2 className="productName">상품명</h2>
              <h2 className="productCount">현재수량</h2>
              <h2 className="todayStock">일일 재고량</h2>
              <h2 className="todayStockTime">일일 재고량 채워지는 시간</h2>
              <h2 className="nowStock">실재고량</h2>
            </div>
            {inventory.map((item: InventoryType, index: number) => {
              return <RenderInventoryItem key={index} item={item} index={index} />;
            })}
          </div>
        </div>
        <button className={`submitButton`} onClick={editInventory}>
          저장
        </button>
      </div>
      <InventoryModal isVisible={visibleModal} setVisible={setVisibleModal} />
    </Style>
  );
};

export default Inventory;

const Style = styled.div`
  .category {
    margin: 20px 0;
  }
  .allCheck label {
    display: flex;
    align-items: center;

    input {
      width: 18px;
      height: 18px;
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      font-weight: 500;
      color: #555;
    }
  }

  /* inventoryTable */
  .inventoryTable {
    width: 100%;
    margin-top: 20px;

    .productCheck {
      flex: 0 0 8%;
      width: 8%;
    }
    .productName {
      flex: 0 0 13%;
      width: 13%;

      h3 {
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .productCount {
      flex: 0 0 12%;
      width: 12%;
    }
    .todayStock {
      flex: 0 0 15%;
      width: 15%;
    }
    .todayStockTime {
      flex: 0 0 25%;
      width: 25%;
    }
    .nowStock {
      flex: 0 0 15%;
      width: 15%;
    }
  }
  .tabletitle {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 30px 12px 30px;
    text-align: center;
    background: #ecf5f3;
    border-radius: 5px 5px 0 0;

    h2 {
      font-size: 12px;
      font-weight: 600;
      color: #555;
    }
  }
  .tableContent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    width: 100%;
    padding: 12px 30px;
    border: 1px solid #e5e5e5;
    border-top: 0;

    input {
      width: 100%;
      padding: 9px 10px;
      border: 1px solid #cecece;
      border-radius: 5px;
      font-size: 14px;
      font-weight: 500;
      color: #555;
    }
    h3 {
      font-size: 14px;
      font-weight: 500;
      color: #555;
    }
  }
  .tableContent:nth-last-child(1) {
    border-radius: 0 0 5px 5px;
  }

  input[type='checkbox'] {
    accent-color: #40977f;
    width: 18px;
    height: 18px;
    vertical-align: middle;
  }

  @media (max-width: 600px) {
    .inventoryTable {
      .productName {
        flex: 0 0 25%;
        width: 25%;
      }
      .todayStockTime {
        flex: 0 0 20%;
        width: 20%;
      }
    }
    .tabletitle {
      padding: 12px;
    }
    .tableContent {
      padding: 12px 10px;
    }
  }
`;
